import { FC, ReactNode } from 'react';
import { Argon, ArgonProps } from '../argon';

interface NeonTypes extends ArgonProps {
  documentTitle?: string;
  title: ReactNode;
  tabs?: ReactNode;
  sider?: ReactNode;
  actions: {
    primary?: ReactNode;
    secondary?: ReactNode;
    central?: ReactNode;
  };
  progress?: number;
  isDistractionFree?: boolean;
  siderResizable?: boolean;
  siderWidth?: number;
  siderOffset?: number;
  siderMinWidth?: number;
  siderMaxWidth?: number;
  onResize?: (width: number) => void;
  onResizeStart?: (width: number) => void;
  onResizeStop?: (width: number) => void;
}

export const Neon: FC<React.PropsWithChildren<NeonTypes>> = ({
  documentTitle,
  title,
  tabs,
  sider,
  progress,
  content,
  actions: { primary, secondary, central },
  isDistractionFree,
  siderResizable,
  siderWidth,
  siderOffset,
  siderMinWidth,
  siderMaxWidth,
  onResize,
  onResizeStart,
  onResizeStop,
  $island,
}) => {
  return (
    <Argon
      isDistractionFree={isDistractionFree}
      documentTitle={documentTitle}
      title={title}
      tabs={tabs}
      sider={sider}
      progress={progress}
      content={content}
      siderResizable={siderResizable}
      siderMinWidth={siderMinWidth}
      siderMaxWidth={siderMaxWidth}
      siderOffset={siderOffset}
      siderWidth={siderWidth}
      actions={{ primary, secondary, central }}
      onResize={onResize}
      onResizeStart={onResizeStart}
      onResizeStop={onResizeStop}
      $island={$island}
    />
  );
};
